"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Version_1 = require("../version/Version");
class ApiVersionHeader {
    static encode(apiVersion) {
        const pomVersion = apiVersion.getPomVersion();
        if (pomVersion?.includes("SNAPSHOT")) {
            return `${apiVersion.getPomVersion()}:${apiVersion.getBuildtime()}`;
        }
        else {
            // Not a snapshot release - we"re only interested in the pom version
            return pomVersion;
        }
    }
    static decode(encoded) {
        const split = encoded.indexOf(":");
        if (split > 0) {
            const pomVersion = encoded.substring(0, split);
            const buildTime = encoded.substring(split + 1);
            if (buildTime && pomVersion) {
                return new Version_1.VersionImpl(undefined, undefined, buildTime, pomVersion);
            }
        }
    }
}
ApiVersionHeader.NAME = "X-Api-Version";
ApiVersionHeader.CONFLICT_MARKER = "API version mismatch";
exports.default = ApiVersionHeader;
//# sourceMappingURL=ApiVersionHeader.js.map